import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { map, tap, catchError, switchMap } from 'rxjs/operators';
import { ConstantsService } from '../../../services/constants.service';
import { Auth } from './../../auth/models/auth.model';
import { Usuario } from 'src/app/models/usuario.model';
import { JsonPipe } from '@angular/common';
import { AlertService } from 'src/app/services/alert.service';

const base_url = environment.base_url;
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private url = ConstantsService.LOGIN_USER_URL;
  private url_Auth_uServices = ConstantsService.API_AUTH_LOGIN_MICROSERVICOS;
  private url_redux = ConstantsService.LOGIN_REDUX_USER_URL;
  private currentUserSubject: BehaviorSubject<Usuario | null>;
  public currentUser: Observable<Usuario | null>;

  private _authenticated: boolean = false;
  private _httpClient = inject(HttpClient);

  // httpsOptions = {
  //   headers: new HttpHeaders({
  //     'Content-Type': 'application/json;charset=utf-8',
  //   })
  // };

  set accessToken(token: string) {
    localStorage.setItem('accessToken', token);
  }

  get accessToken(): string {
    return localStorage.getItem('accessToken') ?? '';
  }

  constructor(
    private http: HttpClient,
    private alert: AlertService,
  ) {
    this.currentUserSubject = new BehaviorSubject<Usuario | null>(<Usuario | null>JSON.parse(localStorage.getItem('currentUser') || 'null'));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get getUsuarioActual(): Usuario | null {
    return this.currentUserSubject.value;
  }

  validateTocken(): Observable<boolean> {
    const tocken = localStorage.getItem('tocken') || '';
    return this.http.get(`${base_url}/renew`, {
      headers: { 'x-tocken': tocken }
    }).pipe(tap((resp: any) => {

      /* TODO
      Renovar Tocken en el backend y guardar en localstorage
      */
      //localStorage.setItem('tocken', resp.tocken)
    }),
      map(resp => resp),//Retornará lo que el back responda | Clase de RX    
      catchError(error => of(false))// Atrapa el error y retorna un false
    );
  }


  authRedux(formData: Auth): Observable<any> {
    let usuario = new Usuario();
    const credentials = { username: formData.nombreUsuario, password: formData.claveUsuario };
    if (this._authenticated) {
      return throwError('El usuario se encuentra autenticado.');
    }
    return this._httpClient.post(this.url_Auth_uServices, credentials).pipe(
      switchMap((respAuth: any) => {
        const accessToken = respAuth.result.token;
        
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${accessToken}`
        });
        
         const httpOptions = {
          headers: headers
        };
        return this._httpClient.post((this.url_redux), formData , httpOptions).pipe(
          map((respRedux: any) => {
            let usuarioApp
            if (respRedux.user.roles && respRedux.user.roles.length > 0) {
              usuario.token = accessToken;
              usuario.idSprUsuario = respRedux.user.usuario[0].idSprUsuario;
              usuario.idSprRol = respRedux.user.usuario[0].idSprRol;
              usuario.idSprNivel = respRedux.user.usuario[0].idSprNivel;
              usuario.idSprAmbiente = respRedux.user.usuario[0].idSprAmbiente
              usuario.nombres = respRedux.user.usuario[0].nombreUsuario;
              usuario.nombreUnidad = respRedux.user.usuario[0].nombreUnidad;
              usuario.userAmbiente = respRedux.user.usuario;
              this.saveLocalStorage(usuario);
              localStorage.setItem("currentUser", JSON.stringify(usuario));
              usuarioApp = {
                access_token: accessToken,// respRedux.access_token, // accede con el TOKEN del servicios 
                token_type: 'Bearer',
                user: respRedux.user
              };
              this.alert.success("¡EXCELENTE!", "Bienvenido al SPR Policial"); 
            } else {
              this.alert.warning("¡Atención!", "El usuario no tiene permisos a este módulo.");
            }
            return usuarioApp;
          })
        );
      }),
      tap((usuarioApp) => console.log('....')),
      catchError((error) => {
        this.alert.warning("¡Atención!", "No se ha podido validar sus credenciales, verifique sus datos de acceso.");
        return throwError(error);
      })
    );
  }

  logout() {
    localStorage.clear();
    this.currentUserSubject.next(null)
  }


  private saveLocalStorage(user: Usuario) {
    localStorage.setItem('tocken', user.token);
  }

}
